import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "choose-project-dropdown_target" }
const _hoisted_2 = { class: "dd-project-icon" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "choose-project-dropdown_text" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "choose-project-dropdown_text" }

import { ProjectModel } from "@/models";
import { onBeforeMount, PropType, ref } from "vue";
import { TirPmDropdown, TirPmDropdownSizeEnum, TirPmIconView, TirPmInput } from "tir-components";
import { TaskParameterTypeEnum } from "../task-parameter";
import { ChevronDownIcon, CheckIcon } from "tir-style-system/icons/outline";
import { AdapterService } from "./adapter-service";
import {
  PencilSquareIcon,
  PlusIcon,
  TrashIcon,
  Squares2X2Icon,
} from "tir-style-system/icons/outline";
/**API сервис */

export default /*#__PURE__*/_defineComponent({
  __name: 'choose-project-dropdown',
  props: {
  modelValue: { type: Object as PropType<ProjectModel> },
  /**Тип проекта */
  type: { type: Number as PropType<TaskParameterTypeEnum> },

},
  emits: ["update:modelValue"],
  setup(__props, { emit }) {

const apiService = new AdapterService();

/**Параметры */

/**События */


/**Список проектов */
const projects = ref<ProjectModel[]>([]);

/**Перед рендером */
onBeforeMount(() => getProjects());

/**Получить список проектов */
const getProjects = async (value: string = "") => {
  const response = await apiService.GetProjects(value);
  if (response.IsSuccess) projects.value = response.Value;
};

/**Выбор проекта */
const selectProject = (project: ProjectModel) => {
  getProjects();
  emit("update:modelValue", project);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TirPmDropdown), {
    class: "choose-project-dropdown",
    width: "16rem",
    popoverWidth: "16rem",
    options: projects.value,
    showOnHover: "",
    size: _unref(TirPmDropdownSizeEnum).Light,
    "selected-option": __props.modelValue,
    isSearchLocal: false,
    isHiddenSearch: false,
    onUpdateSearch: getProjects,
    optionListScrollHeight: "24rem"
  }, {
    target: _withCtx((slot) => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_unref(Squares2X2Icon))
        ]),
        (!__props.modelValue)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, "Выбор проекта"))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createVNode(_unref(TirPmIconView), {
                "is-bordered": false,
                "is-rounded": true,
                size: 24,
                colorCode: __props.modelValue.PreviewColor,
                "image-load-url": __props.modelValue.ImageUrl
              }, {
                mainSlot: _withCtx(() => [
                  _createTextVNode(_toDisplayString(__props.modelValue.Name[0]?.toLocaleUpperCase()), 1)
                ]),
                _: 1
              }, 8, ["colorCode", "image-load-url"]),
              _createElementVNode("div", _hoisted_4, _toDisplayString(__props.modelValue.Name), 1)
            ], 64)),
        _createVNode(_unref(ChevronDownIcon), {
          class: _normalizeClass(["choose-project-dropdown_target_arrow", { open: slot.isOpened }])
        }, null, 8, ["class"])
      ])
    ]),
    optionList: _withCtx((slot) => [
      _createElementVNode("div", {
        class: _normalizeClass(["choose-project-dropdown_option", { selected: __props.modelValue?.Id == slot.option.Id }]),
        onClick: ($event: any) => (selectProject(slot.option))
      }, [
        _createVNode(_unref(TirPmIconView), {
          "is-bordered": false,
          "is-rounded": true,
          size: 24,
          colorCode: slot.option.PreviewColor,
          "image-load-url": slot.option.ImageUrl
        }, {
          mainSlot: _withCtx(() => [
            _createTextVNode(_toDisplayString(slot.option.Name[0]?.toLocaleUpperCase()), 1)
          ]),
          _: 2
        }, 1032, ["colorCode", "image-load-url"]),
        _createElementVNode("div", _hoisted_6, _toDisplayString(slot.option.Name), 1)
      ], 10, _hoisted_5)
    ]),
    _: 1
  }, 8, ["options", "size", "selected-option"]))
}
}

})